import appGlobalScript from '/home/runner/work/surecart-wp/surecart-wp/packages/components/src/global/global.ts';
export const globalScripts = appGlobalScript;
